import Service, { getCallApiFunction } from '../service'
// import denormalizer from './denormalizer'
// import normalizer from './normalizer'

export interface IParams {
  merchantId: number
}

class FetchDeliveryMethodListApi extends Service {
  constructor(params: IParams) {
    super()
    this.name = 'FETCH_DELIVERY_METHOD_LIST'

    this.config = {
      url: `/v1/system/dropdown/logistics`,
      method: 'GET',
      params: { ...params },
    }
  }
}

export const fetchDeliveryMethodList = (params: IParams) => getCallApiFunction(new FetchDeliveryMethodListApi(params))
